<e11-panel>
  <sdk-customer-manage-company-info> </sdk-customer-manage-company-info>
</e11-panel>
